import { Construction, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import MetaTags from '@/components/MetaTags';

const Maintenance = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted p-4">
      <MetaTags
        title="אתר במצב תחזוקה - מיי בילדר"
        description="האתר נמצא כרגע במצב תחזוקה. נחזור בקרוב."
      />
      <Card className="max-w-2xl w-full">
        <CardContent className="p-12 text-center space-y-6">
          <div className="flex justify-center">
            <div className="relative">
              <Construction className="h-24 w-24 text-primary animate-pulse" />
              <AlertTriangle className="h-8 w-8 text-yellow-500 absolute -top-2 -right-2" />
            </div>
          </div>
          
          <div className="space-y-3">
            <h1 className="text-4xl font-bold text-foreground">
              אתר במצב תחזוקה
            </h1>
            <p className="text-xl text-muted-foreground">
              האתר נמצא כעת במצב תחזוקה ושדרוג
            </p>
          </div>

          <div className="bg-muted/50 rounded-lg p-6 space-y-2">
            <p className="text-lg text-foreground font-medium">
              אנחנו עובדים על שיפורים חדשים
            </p>
            <p className="text-muted-foreground">
              האתר יחזור לפעילות בקרוב. תודה על הסבלנות!
            </p>
          </div>

          <div className="pt-6 border-t">
            <p className="text-sm text-muted-foreground">
              לפניות דחופות: צור קשר עם התמיכה שלנו
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Maintenance;
